<script setup>
import {
  computed,
} from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({
  status: {
    type: String,
    default: ''
  }
})

const statusMsg = computed(() => {
  return t('pages.CompaniesStoreSnsPost.index.status.' + props.status)
})
</script>

<template>
  <p class="statusMsg" :class="{ 'statusMsg__error': props.status === 'error' }">
    <span :class="`statusMark__${props.status}`" class="statusMark" />
    {{ statusMsg }}
  </p>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.statusMsg__error {
  color: $color-accent-primary;
}
.statusMark {
  border-radius: 50%;
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 2px;
  &__error {
    background: $color-accent-primary;
  }
  &__complete {
    background: $complete-color;
  }
  &__progress {
    background: #D2D5DB;
  }
  &__rejected {
    background: $color-accent-primary;
  }
  &__requesting {
    background: $complete-color;
  }
  &__draft {
    background: #D2D5DB;
  }
}
</style>
